import { Component, OnInit } from '@angular/core';
import { AbstractFieldComponent } from '../../abstract/abstract-field.component';
import {FormFieldService} from '../../../services/form-field.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-radio',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent extends AbstractFieldComponent implements OnInit {

  get captionAdditionalTrue(): string {
    return this.fieldConfig.captionAdditionalTrue ? this.fieldConfig.captionAdditionalTrue : 'yes';
  }

  get captionAdditionalFalse(): string {
    return this.fieldConfig.captionAdditionalFalse ? this.fieldConfig.captionAdditionalFalse : 'no';
  }

  constructor(public formFieldService: FormFieldService,
              private ts: TranslateService) {
    super(formFieldService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.handleStatusChanges();
  }

  async valueLabel() {
    let valueLabel;
    if (isNotNullOrUndefined(this.control.value)) {
      if (this.fieldConfig.radioConfig) {
        const selectedOption = this.fieldConfig.radioConfig.find(radioOption => radioOption.value === this.control.value);
        valueLabel = selectedOption ? selectedOption.label : null;
      } else {
        valueLabel = this.control.value ? this.captionAdditionalTrue : this.captionAdditionalFalse;
      }
    }
    return valueLabel ? this.ts.instant(valueLabel) : null;
  }

  async onClick(event) {
    this.control.markAsDirty();
    setTimeout(() => super.onClick(event), 0);
  }
}
